import {
  finleyAssert,
  typeguards as commonTypeguards,
} from '@finley-technologies/common';
import { CreditAgreement, Util } from '@finley-technologies/finley-types';

import { BaseFormFields } from '~/core/routes/settings/implementations/[implementationId]/facilities/[facilityId]/facility-mechanics/FacilityMechanics';

type CreditAgreementFullArtifact = CreditAgreement.DomainEntity.CreditAgreementFullArtifact;

export const getFormValues = (
  creditAgreement: CreditAgreementFullArtifact,
): BaseFormFields => {
  const { facilityMechanics: fm } = creditAgreement;

  const closingDateRaw = fm.closingDate.value;
  let closingDate: Util.FullDateStr | null = null;
  if (closingDateRaw) {
    finleyAssert(
      commonTypeguards.isFullDateStr(closingDateRaw),
      `Expected closingDateRaw to be FullDateStr, but got ${closingDateRaw}`,
    );
    closingDate = closingDateRaw;
  }

  const finalMaturityDateRaw = fm.finalMaturityDate.value;
  let finalMaturityDate: Util.FullDateStr | null = null;
  if (finalMaturityDateRaw) {
    finleyAssert(
      commonTypeguards.isFullDateStr(finalMaturityDateRaw),
      `Expected finalMaturityDateRaw to be FullDateStr, but got ${finalMaturityDateRaw}`,
    );
    finalMaturityDate = finalMaturityDateRaw;
  }

  const amortizationPeriodStartRaw = fm.amortizationPeriodStart?.value ?? null;
  let amortizationPeriodStart: Util.FullDateStr | null = null;
  if (amortizationPeriodStartRaw) {
    finleyAssert(
      commonTypeguards.isFullDateStr(amortizationPeriodStartRaw),
      `Expected amortizationPeriodStartRaw to be FullDateStr, but got ${amortizationPeriodStartRaw}`,
    );
    amortizationPeriodStart = amortizationPeriodStartRaw;
  }

  const callProtectionExpirationDateRaw =
    fm.callProtectionExpirationDate?.value ?? null;
  let callProtectionExpirationDate: Util.FullDateStr | null = null;
  if (callProtectionExpirationDateRaw) {
    finleyAssert(
      commonTypeguards.isFullDateStr(callProtectionExpirationDateRaw),
      `Expected callProtectionExpirationDateRaw to be FullDateStr, but got ${callProtectionExpirationDateRaw}`,
    );
    callProtectionExpirationDate = callProtectionExpirationDateRaw;
  }

  const yieldMaintenanceRaw = fm.yieldMaintenance?.value ?? null;
  let yieldMaintenance: Util.FullDateStr | null = null;
  if (yieldMaintenanceRaw) {
    finleyAssert(
      commonTypeguards.isFullDateStr(yieldMaintenanceRaw),
      `Expected yieldMaintenanceRaw to be FullDateStr, but got ${yieldMaintenanceRaw}`,
    );
    yieldMaintenance = yieldMaintenanceRaw;
  }

  const result: BaseFormFields = {
    // Set values for required fields
    closingDate,
    finalMaturityDate,
    maturityDateDescription: fm.finalMaturityDate.description || '',
    termLoan: creditAgreement.loanMechanicsV1?.isTermLoan ? 'true' : 'false',
  };

  // Overwrite values if they exist in CA
  if (fm.amortizationPeriodStart) {
    result.amortizationPeriodStart = amortizationPeriodStart;
  }

  if (fm.callProtectionExpirationDate) {
    result.callProtectionExpirationDate = callProtectionExpirationDate;
  }

  if (fm.callProtectionValue) {
    result.callProtectionValue = fm.callProtectionValue.value;
  }

  if (fm.governingLaw) {
    result.governingLaw = fm.governingLaw.value;
  }

  if (fm.minimumUtilization) {
    result.minimumUtilization = fm.minimumUtilization.value;
  }

  if (fm.yieldMaintenance) {
    result.yieldMaintenance = yieldMaintenance;
  }

  return result;
};
